import type { ReactNode } from 'react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@monksflow/monks-ui';

export interface DisabledReasonTooltipProps {
  reason: string;
  children: ReactNode;
}

/** Names, on hover, why the disabled control inside is unavailable. */
export const DisabledReasonTooltip = ({ reason, children }: DisabledReasonTooltipProps) => (
  <TooltipProvider delayDuration={300}>
    <Tooltip>
      <TooltipTrigger asChild>
        {/* A disabled control swallows pointer events, so the span is what the tooltip hears. */}
        <span>{children}</span>
      </TooltipTrigger>
      <TooltipContent side="left">{reason}</TooltipContent>
    </Tooltip>
  </TooltipProvider>
);
